import { render, staticRenderFns } from "./ThreeTerminal.vue?vue&type=template&id=3a87b33f&scoped=true&"
import script from "./ThreeTerminal.vue?vue&type=script&lang=js&"
export * from "./ThreeTerminal.vue?vue&type=script&lang=js&"
import style0 from "./ThreeTerminal.vue?vue&type=style&index=0&id=3a87b33f&prod&lang=less&"
import style1 from "./ThreeTerminal.vue?vue&type=style&index=1&id=3a87b33f&prod&lang=less&scoped=true&"
import style2 from "./ThreeTerminal.vue?vue&type=style&index=2&id=3a87b33f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87b33f",
  null
  
)

export default component.exports